import React, { useState } from "react";
import useProfileData from "../../../hooks/userProfileData";
import './MeusDados.css';
import EditarPerfil from './EditarPerfil';

const ProfileInfo = () => {
  const { profileData, loading, error } = useProfileData();
  const [editarDados, setEditarDados] = useState(false);
  const [updatedData, setUpdatedData] = useState(null);

  const toggleEditarDados = () => {
    setEditarDados(!editarDados);
  };

  const handleEditSuccess = (data) => {
    setUpdatedData(data);
    toggleEditarDados();
  };

  return (
    <div className="meus-dados-container">
      {editarDados ? (
        <EditarPerfil onSuccess={handleEditSuccess} />
      ) : (
        <>
          <h2>Informações do Perfil</h2>
          {/* Render updated data if available, else render original data */}
          <p>Email: {updatedData?.email || profileData?.email}</p>
          <p>Nome: {updatedData?.nome || profileData?.nome}</p>
          <p>CPF: {updatedData?.cpf || profileData?.cpf}</p>
          <p>Telefone: {updatedData?.telefone || profileData?.telefone}</p>
          <p>Profissão: {updatedData?.profissao || profileData?.profissao}</p>
        </>
      )}
      <button onClick={toggleEditarDados}>Editar Dados</button>
    </div>
  );
};

export default ProfileInfo;
